<template>
	<v-container fluid class="pa-4" style="max-width: 900px">
		<v-btn text small @click="goBack" class="mb-2">
			<v-icon left small>mdi-arrow-left</v-icon> Indietro
		</v-btn>

		<v-card v-if="loading" flat class="text-center pa-8">
			<v-progress-circular indeterminate color="primary"></v-progress-circular>
		</v-card>

		<v-card v-else-if="item" outlined>
			<v-card-title class="d-flex align-start">
				<span class="text-h6">{{ item.title }}</span>
				<v-spacer></v-spacer>
				<v-chip dark :color="item.status_color">{{ item.status_label }}</v-chip>
			</v-card-title>
			<v-card-subtitle>
				Aperta il {{ formatDate(item.created_at) }}
				<span v-if="item.created_by_portal"> · segnalazione tua</span>
			</v-card-subtitle>
			<v-divider></v-divider>

			<v-card-text>
				<div class="text-subtitle-2 mb-1">Descrizione</div>
				<div v-if="item.description" v-html="sanitizeHtml(item.description)"></div>
				<div v-else class="grey--text font-italic">Nessuna descrizione</div>
			</v-card-text>

			<template v-if="item.attachments && item.attachments.length">
				<v-divider></v-divider>
				<v-card-text>
					<div class="text-subtitle-2 mb-2">Allegati</div>
					<v-list dense>
						<v-list-item v-for="a in item.attachments" :key="a.id" @click="downloadAttachment(a)">
							<v-list-item-avatar>
								<v-icon>mdi-paperclip</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title>{{ a.name }}.{{ a.ext }}</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-icon small>mdi-download</v-icon>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-card-text>
			</template>

			<template v-if="item.can_confirm">
				<v-divider></v-divider>
				<v-card-actions class="pa-4 flex-wrap">
					<v-icon left color="purple">mdi-help-circle-outline</v-icon>
					<span class="text-body-2">Il team ha completato l'intervento: confermi che è risolto?</span>
					<v-spacer></v-spacer>
					<v-btn color="success" :loading="confirming" @click="confirmResolution">
						<v-icon left>mdi-check</v-icon>Conferma risoluzione
					</v-btn>
				</v-card-actions>
			</template>
		</v-card>

		<v-card v-if="item" outlined class="mt-4">
			<v-card-text>
				<portal-comments :key="itemId" :item-id="itemId"></portal-comments>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import PortalComments from '@/components/modules/portal/PortalComments'
import { sanitizeHtml } from '@/utils/sanitizeHtml'

export default {
	name: 'PortalItemDetail',
	components: { PortalComments },
	data() {
		return {
			item: null,
			loading: false,
			confirming: false
		}
	},
	computed: {
		itemId() {
			return this.$route.params.id
		}
	},
	watch: {
		// La stessa route items/:id viene riusata: ricarica al cambio di id
		itemId() {
			this.loadItem()
		}
	},
	created() {
		this.loadItem()
	},
	methods: {
		sanitizeHtml,
		async loadItem() {
			this.loading = true
			try {
				const resp = await this.axios.get('portal/items/' + this.itemId)
				if (resp.data.success) this.item = resp.data.data
			} catch (e) {
				if (e.response && e.response.status === 404) {
					this.$store.commit('setSnackbar', { value: true, text: 'Segnalazione non disponibile.', color: 'warning', timeout: 5000 })
					this.$router.replace('/portal/projects')
				} else {
					this.$store.commit('setSnackbarError')
				}
			} finally {
				this.loading = false
			}
		},
		async downloadAttachment(a) {
			try {
				const response = await this.axios.get('portal/items/' + this.itemId + '/attachments/' + a.id + '/download', {
					responseType: 'blob',
					headers: { Accept: '*/*' }
				})
				const blob = new Blob([response.data], { type: response.headers['content-type'] })
				const url = window.URL.createObjectURL(blob)
				const link = document.createElement('a')
				link.href = url
				link.download = a.name.endsWith('.' + a.ext) ? a.name : a.name + '.' + a.ext
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
				window.URL.revokeObjectURL(url)
			} catch (e) {
				this.$store.commit('setSnackbarError')
			}
		},
		async confirmResolution() {
			this.confirming = true
			try {
				const resp = await this.axios.post('portal/items/' + this.itemId + '/confirm')
				if (resp.data.success) {
					this.item = resp.data.data
					this.$store.commit('setSnackbar', { value: true, text: 'Risoluzione confermata. Grazie!', color: 'success', timeout: 4000 })
				}
			} catch (e) {
				this.$store.commit('setSnackbarError')
			} finally {
				this.confirming = false
			}
		},
		goBack() {
			this.$router.back()
		},
		formatDate(date) {
			if (!date) return ''
			return new Date(date).toLocaleDateString('it-IT', {
				day: '2-digit', month: '2-digit', year: 'numeric',
				hour: '2-digit', minute: '2-digit'
			})
		}
	}
}
</script>
